export const elasticUrls = {
  getFields: (index) => {return `/${index}`},
  deleteComments:(id)=>{return `/comments/_doc/${id}`},
  getComments: '/comments/_doc/_search',
  postComments: '/comments/_doc/',
  putComments: (id)=>{return `/comments/_doc/${id}`},
  getByIndex: (index) => {return `/${index}/_search`},
}